import { Controller } from "@hotwired/stimulus"
import RequestHelper from "../helpers/request_helper"

// Owns the "Cancel upcoming gift?" confirmation modal (upcoming_gifts/_cancel_modal.html.haml).
// Opened by a row's trash can (single gift) or by upcoming_gifts_controller.js's
// "upcoming-gifts:bulk-cancel" event (the checked gifts). Announces a successful cancel with
// "upcoming-gift-cancel:canceled" so the page can refresh its list; with reload set, it reloads the
// page itself.
export default class extends Controller {
  static get targets() {
    return ["modal", "title", "body", "keepButton", "confirmButton"];
  }

  static get values() {
    return { bulkUrl: String, reload: Boolean };
  }

  open(event) {
    event.preventDefault();
    const { url, recipient, date } = event.params;

    this.request = { url, body: null };
    this.titleTarget.textContent = "Cancel upcoming gift?";
    this.bodyTarget.textContent = `The gift to ${recipient} on ${date} won't be sent, and this action can't be undone.`;
    this.keepButtonTarget.textContent = "Keep it";
    this.show();
  }

  openBulk(event) {
    const { keys } = event.detail;
    if (!keys || keys.length === 0) { return; }

    const single = keys.length === 1;
    this.request = { url: this.bulkUrlValue, body: JSON.stringify({ keys }) };
    this.titleTarget.textContent = `Cancel ${keys.length} upcoming ${single ? "gift" : "gifts"}?`;
    this.bodyTarget.textContent = `${single ? "This gift won't" : "These gifts won't"} be sent, and this action can't be undone.`;
    this.keepButtonTarget.textContent = single ? "Keep it" : "Keep them";
    this.show();
  }

  confirm(event) {
    event.preventDefault();
    if (!this.request) { return; }

    const options = RequestHelper.defaultPatchOptions();
    options.headers["Accept"] = "application/json";
    if (this.request.body) {
      options.headers["Content-Type"] = "application/json";
      options.body = this.request.body;
    }

    this.confirmButtonTarget.disabled = true;
    fetch(this.request.url, options).
      then((response) => response.json().then((data) => ({ ok: response.ok, data }))).
      then(({ ok, data }) => {
        this.hide();
        if (!ok) {
          window.ltAlert({ message: data.message, type: "toast-error" });
          return;
        }

        window.ltAlert({ message: data.message, type: "toast-success" });
        this.dispatch("canceled", { detail: data });
        if (this.reloadValue) { window.Turbo.visit(window.location.href, { action: "replace" }); }
      }).
      catch(() => {
        this.hide();
        window.ltAlert({ message: "An error occurred, please try again later.", type: "toast-error" });
      }).
      finally(() => {
        this.confirmButtonTarget.disabled = false;
        this.request = null;
      });
  }

  show() {
    $(this.modalTarget).modal("show");
  }

  hide() {
    $(this.modalTarget).modal("hide");
  }
}
